export const SORT_DIRECTIONS = [
  'asc',
  'desc',
]




// WEBPACK FOOTER //
// ./src/constants/sort.js